export const messages = {
  en: {
    convenienceMenus: {
      title: 'Convenience Services',
      assetId: 'Asset ID',
      menuName: 'Menu Name',
      imageUrl: 'Image URL',
      pagePath: 'Page Path',
      displayOrder: 'Display Order',
      remark: 'Remark',
      fetchError: 'Failed to fetch convenience menus',
      addTitle: 'Add Convenience Menu',
      editTitle: 'Edit Convenience Menu',
      deleteConfirm: 'Are you sure to delete this convenience menu?'
    }
  },
  zh: {
    convenienceMenus: {
      title: '便民服务',
      assetId: '资产ID',
      menuName: '菜单名称',
      imageUrl: '图片地址',
      pagePath: '页面路径',
      displayOrder: '显示序号',
      remark: '备注',
      fetchError: '获取便民服务菜单失败',
      addTitle: '添加便民服务菜单',
      editTitle: '修改便民服务菜单',
deleteConfirm: '确定删除便民服务菜单吗?'
    }
  },
  'zh-TW': {
    convenienceMenus: {
      title: '便民服務',
      assetId: '資產ID',
      menuName: '選單名稱',
      imageUrl: '圖片地址',
      pagePath: '頁面路徑',
      displayOrder: '顯示序號',
      remark: '備註',
      fetchError: '獲取便民服務選單失敗',
      addTitle: '添加便民服務選單',
      editTitle: '修改便民服務選單',
      deleteConfirm: '確定刪除便民服務選單嗎?'
    }
  }
}